import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  mainAccountInvoice: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  dynamicFields: [

  ],
  analytics: [],
  current_page: 1,
  per_page: PAGELENGTH,
}

export const mainAccountInvoiceSlice = createSlice({
  name: 'mainAccountInvoice',
  initialState: initialState,
  reducers: {
    setMainAccountInvoice: (state, { payload }) => {
      state.mainAccountInvoice = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMainAccountInvoices: (state, { payload }) => {
      state.mainAccountInvoice = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setDynamicFields: (state, { payload }) => {
      state.dynamicFields = payload?.data||payload;
    },
    setMoremainAccountInvoice: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
    },
    removeMainSubAccount: (state, { payload }) => {
      state.error = payload
    },
    clearAllMainSubAccount: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const fetchMainAccountInvoices = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchMainAccountInvoices(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          // dispatch(setMainAccountInvoices(result.data.data));
          return result?.data?.data;
        } else {
          dispatch(setMainAccountInvoices(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setMainAccountInvoices(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }else{
      !disableLoader && dispatch(setLoader(false))
    }
  } catch (error) {
    console.log("error", error)
    !disableLoader && dispatch(setLoader(false))
  }
}


export const { setMainAccountInvoice, setMainAccountInvoices, clearAllMainSubAccount, setLoader, setError, setMoremainAccountInvoice, setDynamicFields } = mainAccountInvoiceSlice.actions


export default mainAccountInvoiceSlice.reducer
export const mainAccountInvoiceSelector = state => state.mainAccountInvoice


